module.exports = __webpack_public_path__ + "static/img/Malakai-Champion.a32e839.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Malakai-Champion.jpg
// module id = CQsv
// module chunks = 0